import React from "react";
import { Platform, View } from "react-native";
import { ids, styles } from "./Style";
import PageWrapper from "../../components/common/PageWrapper";
import { ScreenNameList } from "@lib/utilities/Constants";
import { useDocumentsInfo } from "@lib/hooks/docs/useDocumentsInfo";
import { withPolicyDataFetching } from "../../hoc/withFetchPolicyData";
import DocumentContentView from "../../components/docs/DocumentContentView";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import MainContainer from "../../components/common/MainContainer";

const DocumentsInfo = ({ navigation }: any) => {
  const {
    errorData,
    detailedPolicy,
    arrayPolicyList,
    documentsArray,
    loading,
    flatListRef,

    onReloadPress,
    moveNextPreviousHorizontalFlatlist,
    onViewableItemsChanged,
    onEndTimer,

    onPdfItemTap,
    currentIndex,
    itemPressedFlag,
  } = useDocumentsInfo(navigation);

  return (
    <MainContainer
      screenName={ScreenNameList.documentInfo}
      navigation={navigation}
      errorData={errorData}
      onReloadPress={onReloadPress}
      onEndTimer={onEndTimer}
    >
      <View
        style={[styles.mainContainer]}
        dataSet={{ media: ids.mainContainer }}
      >
        <PageWrapper
          screenName={ScreenNameList.documentInfo}
          navigation={navigation}
          isLoading={loading}
          arrayPolicyList={arrayPolicyList}
        >
          {!loading && detailedPolicy != "" ? (
            <DocumentContentView
              documentsArray={documentsArray}
              currentIndex={currentIndex}
              moveNextPreviousHorizontalFlatlist={
                moveNextPreviousHorizontalFlatlist
              }
              flatListRef={flatListRef}
              onViewableItemsChanged={onViewableItemsChanged}
              onPdfItemTap={onPdfItemTap}
            />
          ) : (
            <></>
          )}
        </PageWrapper>
        {itemPressedFlag && <View style={styles.pdfItemView}></View>}
      </View>
    </MainContainer>
  );
};

export default Platform.OS=='web'?withAuthenticationRequired(withPolicyDataFetching(DocumentsInfo)):withPolicyDataFetching(DocumentsInfo);
